module.exports={Remove:"제거"};